export const getModelSideImageUrl = (sideImagePath) => `/models/${sideImagePath}`;
